import { SvgIcon, SvgIconProps } from "@mui/material";

export const ChecklistDualIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5H20"
        stroke="#5563F5"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="6"
        cy="5"
        r="2"
        fill="#B7BDFB"
        stroke="#5563F5"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 12H20"
        stroke="#5563F5"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 19H20"
        stroke="#5563F5"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="6"
        cy="12"
        r="2"
        fill="#B7BDFB"
        stroke="#5563F5"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="6"
        cy="19"
        r="2"
        fill="#B7BDFB"
        stroke="#5563F5"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);
